<!-- <pre>{{breadcrumbs | async | json}}</pre> -->

<div class="breadcrumb-large">
  <ol class="breadcrumb">

    <li class="breadcrumb-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}">
      <a [routerLink]=" ['/']">
        {{'common.home' | translate}}
      </a>
    </li>

    <li class="breadcrumb-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}"
      *ngFor="let crumb of breadcrumbs | async; last as isLast">

      <a [routerLink]="[crumb.url]" *ngIf="!isLast">
        <ng-container *ngIf="crumb.dynamicLabel">
          {{crumb.label}}
        </ng-container>

        <ng-container *ngIf="!crumb.dynamicLabel">
          {{(crumb.label) | translate }}
        </ng-container>
      </a>

      <span class="text-muted" *ngIf="isLast">
        <ng-container *ngIf="crumb.dynamicLabel">
          {{crumb.label}}
        </ng-container>

        <ng-container *ngIf="!crumb.dynamicLabel">
          {{(crumb.label) | translate }}
        </ng-container>
      </span>

    </li>

  </ol>

</div>

<div class="breadcrumb-small">

  <div class="btn-group" dropdown>
    <button dropdownToggle type="button" class="btn btn-sm btn-light dropdown-toggle">

      <ng-container *ngIf="(breadcrumbs | async)?.length">
        <span *ngFor="let crumb of breadcrumbs | async | slice:(breadcrumbs | async).length -1">
          {{'common.page' | translate}} &middot; {{(crumb.label) | translate}}
        </span>
        <span class="caret"></span>
      </ng-container>

      <ng-container *ngIf="!(breadcrumbs | async)?.length">
        {{'common.page' | translate}} &middot; {{'common.home' | translate}}
        <span class="caret"></span>
      </ng-container>


    </button>
    <div *dropdownMenu class="dropdown-menu text-sm" role="menu">

      <a class="dropdown-item" [routerLink]=" ['/']">
        {{'common.home' | translate}}
      </a>

      <ng-container *ngFor="let crumb of breadcrumbs | async; last as isLast">

        <a class="dropdown-item" [ngClass]="{'bg-light' : isLast}" [routerLink]="[crumb.url]">
          <ng-container *ngIf="crumb.dynamicLabel">
            {{crumb.label}}
          </ng-container>

          <ng-container *ngIf="!crumb.dynamicLabel">
            {{(crumb.label) | translate }}
          </ng-container>
        </a>

      </ng-container>

    </div>
  </div>

</div>